import { TFunction } from "i18next";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { Title } from "src/components";
import { colors } from "src/constants/colors";
import { BsPlugin } from "react-icons/bs";
import { Element } from "react-scroll";


const servicesData = (t: TFunction) => [
    {
        title: t("services.items.electronics_import.title"),
        description: t("services.items.electronics_import.description"),
    },
    {
        title: t("services.items.air_purification.title"),
        description: t("services.items.air_purification.description"),
    },
    {
        title: t("services.items.restaurants_hotels.title"),
        description: t("services.items.restaurants_hotels.description"),
    },
    {
        title: t("services.items.elevators.title"),
        description: t("services.items.elevators.description"),
    },
    {
        title: t("services.items.wires_switches_lights.title"),
        description: t("services.items.wires_switches_lights.description"),
    },
    {
        title: t("services.items.electric_panels.title"),
        description: t("services.items.electric_panels.description"),
    },
    {
        title: t("services.items.electrical_accessories.title"),
        description: t("services.items.electrical_accessories.description"),
    },
    {
        title: t("services.items.audio_visual.title"),
        description: t("services.items.audio_visual.description"),
    },
    {
        title: t("services.items.phones.title"),
        description: t("services.items.phones.description"),
    },
    {
        title: t("services.items.photography_equipment.title"),
        description: t("services.items.photography_equipment.description"),
    },
    {
        title: t("services.items.computers.title"),
        description: t("services.items.computers.description"),
    },
    {
        title: t("services.items.watches_glasses.title"),
        description: t("services.items.watches_glasses.description"),
    },
    {
        title: t("services.items.measuring_tools.title"),
        description: t("services.items.measuring_tools.description"),
    },
    {
        title: t("services.items.home_supplies.title"),
        description: t("services.items.home_supplies.description"),
    }
];

const Services = () => {
    const { t } = useTranslation("home");
    const services = servicesData(t);

    return (
        <Element name="services" className={styles.section}>
            <div className="container">
                <div className={styles.inlineCon}>

                    <Title
                        lgTitle={t("services.sub_title")}
                        smTitle={t("services.title")}
                        lgTitleColor={colors.heading}
                        smTitleColor={colors.primary}
                    />

                    <div className="row mt-5">
                        {services.map((item, index) => (
                            <div
                                key={item.title}
                                className="col-lg-4 col-md-6 col-12 mb-3 pb-2 px-2"
                                data-aos="fade-up"
                                data-aos-delay={index}
                                data-aos-anchor-placement="top-bottom"
                            >
                                <div className={styles.card}>

                                    {/* React Icon */}
                                    <div className={styles.iconWrapper}>
                                        <BsPlugin size={96} className={styles.icon} />
                                    </div>

                                    <h3 className={styles.cardTitle}>{item.title}</h3>
                                    <p className={`global-p ${styles.cardText}`}>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </Element>
    );
};

export default Services;
